import { gql } from '@apollo/client';

export default gql`
  mutation deleteStepItem($_id: String) {
    deleteStepItem(_id: $_id) {
      ok
      message
      error
    }
  }
`;
